import { AxiosRequestConfig } from 'axios'
import {
  File as Data,
  FileCollection as Collection,
} from '@/typings/api/File'
import {
  BaseApiResponse as BR,
  BaseApiResponseCollection as BRC,
} from '@/typings/common'

import { BaseApiAuth } from '@/api/BaseApiAuth'


export class FilesApi extends BaseApiAuth<Data, Collection> {
  protected readonly endpoint = 'publications/files';

  public getTags(params: unknown, config: AxiosRequestConfig = {}) {
    const path = 'tags/'
    const [url] = this.getUrl(path)
    return this.request<never, BRC<string>>('GET', url, { params, ...config })
  }

  public upload(file: File, config: AxiosRequestConfig = {}) {
    const path = 'upload/'
    const [url] = this.getUrl(path)
    const data = new FormData()
    data.append('file', file)
    return this.request<never, BR<Data['raw_file']>>('POST', url, { data, ...config })
  }
}
